<template>
  <div class="customerDetail">
    <div class="header">
      <div class="dropdownMenu">
        <div class="dropdown dropleft">
          <button
            type="button"
            id="dropdownMenuButton"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <i class="fas fa-ellipsis-v"></i>
          </button>
          <div class="dropdown-container">
            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <h5 class="dropdown-heading">Schedules</h5>
              <div class="dropdown-item-wrap">
                <img :src="demotask" alt="Edit" />
                <a class="dropdown-item" href="#">Set Demo Date</a>
              </div>
              <div class="dropdown-item-wrap">
                <img :src="setfollowup" alt="Edit" />
                <a class="dropdown-item" href="#">Set Followup Date</a>
              </div>
              <div class="dropdown-item-wrap">
                <img :src="setestimated" alt="Edit" />
                <a class="dropdown-item" href="#">Set Estimated Value</a>
              </div>
              <div class="border"></div>
              <h5 class="dropdown-heading">Priority</h5>
              <div class="dropdown-icon-wrap" :class="{ 'set-height': setHeight }">
                <div class="dropdown-item-wrap">
                  <img :src="setpriority" alt="Edit" />
                  <a class="dropdown-item" @click.stop="togglePriorityDropdown">Select Priority</a>

                  <div
                    class="dropdown-menu second-dropdown"
                    :class="{ 'dropdown-menu-right': showPriorityDropdown }"
                    v-show="showPriorityDropdown"
                  >
                    <a class="dropdown-item" href="#">No Priority</a>
                    <a class="dropdown-item" href="#">Less Interested</a>
                    <a class="dropdown-item" href="#">Interested</a>
                    <a class="dropdown-item set-item-style" href="#"
                      >Highly Interested</a
                    >
                  </div>
                </div>
                <div class="dropdown-icon" @click.stop="togglePriorityDropdown">
                  <img :src="dropdownarrow" alt="Edit" />
                </div>
              </div>
              <div class="border"></div>
              <div class="dropdown-item-wrap">
                <img :src="deleteIcon" alt="Edit" />
                <a class="dropdown-item" href="#">Delete</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="statusWrapper">
      <div class="status1 statusBadge">INACTIVE</div>
      <div class="status2 statusBadge">qualified</div>
    </div>

    <div class="customerInfo">
      <div class="customerImg">
        <img :src="avatarIcon" alt="" />
      </div>
      <div class="customerName">
        <h1
          class="customerNameText"
          :class="isEditable.name ? 'focusInput' : ''"
          :contenteditable="isEditable.name"
          @input="updateText('name', $event)"
          ref="editableName"
        >
          {{ demo.company }}
        </h1>

        <div class="customerNameEdit">
<!--          <button v-if="!isEditable.name" @click="toggleEdit('name')">-->
<!--            <img :src="pencilEdit" alt="Edit" />-->
<!--          </button>-->

<!--          <div v-if="isEditable.name" class="editableButton">-->
<!--            <button @click="saveEdit('name')" class="isEdit">-->
<!--              <img :src="tickIcon" alt="save" />-->
<!--            </button>-->
<!--            <button @click="cancelEdit('name')" class="isEdit isEditCancle">-->
<!--              <i class="fa fa-times" aria-hidden="true"></i>-->
<!--            </button>-->
<!--          </div>-->
        </div>
      </div>

      <v-row class="justify-content-center">
        <div class="contact-wrapper">
          <v-col
            cols="12"
          >
            <div class="contactSource row justify-content-between align-items-baseline">
              <v-col
                cols="" class="contact-col"
              >
                <div class="contact-cards" >
                  <a @click.prevent="openTab('Notes')">
                    <img :src="notesIcon" alt="" />
                  </a>
                </div>
                <a > 
                <span  class="card-heading2">Notes</span>
                </a>
              </v-col>
              <v-col
                cols="" class="contact-col"
              >
                <div class="contact-cards" @click.prevent="openTab('Email')">
                  <a >
                    <img :src="emailIcon" alt="" />
                  </a>
                </div>
                <a > 
                <span class="card-heading2">Email</span>
                </a>
              </v-col>
              <v-col
                cols="" class="contact-col"
              >
                <div class="contact-cards">
                  <a href="">
                    <img :src="callIcon" alt="" />
                  </a>
                </div>
                <a href="">
                <span class="card-heading2"> Call </span>
                </a>
              </v-col>
              <v-col
                cols="" class="contact-col"
              >
                <div class="contact-cards" @click.prevent="openTab('Meet')">
                  <a >
                    <img :src="meetIcon" alt="" />
                  </a>
                </div>
                <a > 
                <span class="card-heading2">Meet</span>
                </a>
              </v-col>
            </div>
          </v-col>
        </div>
      </v-row>
    </div>
    <v-row class="justify-content-center">
      <div class="progress-wrapper">
        <v-col cols="xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <b-progress class="mt-2" :max="progressMax">
            <b-progress-bar
              v-b-tooltip.bottom="'Success Tooltip Text'"
              :value="progressValue * (3.33 / 10)"
              variant="success"
            ></b-progress-bar>
            <b-progress-bar
              v-b-tooltip.bottom="'Success Tooltip Text'"
              :value="progressValue * (3.33 / 10)"
              variant="warning"
            ></b-progress-bar>
            <b-progress-bar
              v-b-tooltip.bottom="'Success Tooltip Text'"
              :value="progressValue * (3.33 / 10)"
              variant="danger"
            ></b-progress-bar>
          </b-progress>
        </v-col>
      </div>
    </v-row>
    <!-- <v-row class="justify-content-center">
      <v-col cols="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
        <div class="interested-content">
          <h2 class="interested-heading">Highly Interested</h2>
          <div class="triangle"></div>
        </div>
      </v-col>
    </v-row> -->

    <v-row>
      <v-col cols="12">
        <div class="detailborder-bottom"></div>
      </v-col>
    </v-row>

    <div class="customer-info-wrapper hide-scroll">
      <v-row>
        <v-col cols="12">
          <div class="customer-info">
            <h3 class="main-heading">Customer Details</h3>
            <div class="customer-name2">
              <h5 class="sub-heading1">Name</h5>
              <div class="customerNameEdit2">
                <h6
                  class="sub-heading2"
                  :class="isEditable.username ? 'focusInput' : ''"
                  :contenteditable="isEditable.username"
                  @input="updateText('username', $event)"
                  ref="editableUsername"
                >
                  {{ demo.name }}
                </h6>
                <div class="customerNameEdit">
<!--                  <button-->
<!--                    v-if="!isEditable.username"-->
<!--                    @click="toggleEdit('username')"-->
<!--                  >-->
<!--                    <img :src="pencilEdit" alt="Edit" />-->
<!--                  </button>-->

                  <div v-if="isEditable.username" class="editableButton">
                    <button @click="saveEdit('username')" class="isEdit">
                      <img :src="tickIcon" alt="save" />
                    </button>
                    <button
                      @click="cancelEdit('username')"
                      class="isEdit isEditCancle"
                    >
                      <i class="fa fa-times" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="customer-name2">
              <h5 class="sub-heading1">Email</h5>
              <div class="customerNameEdit2">
                <h6
                  class="sub-heading2"
                  :class="isEditable.email ? 'focusInput' : ''"
                  :contenteditable="isEditable.email"
                  @input="updateText('email', $event)"
                  ref="editableEmail"
                >
                  {{ demo.email }}
                </h6>
                <div class="customerNameEdit">
<!--                  <button v-if="!isEditable.email" @click="toggleEdit('email')">-->
<!--                    <img :src="pencilEdit" alt="Edit" />-->
<!--                  </button>-->

                  <div v-if="isEditable.email" class="editableButton">
                    <button @click="saveEdit('email')" class="isEdit">
                      <img :src="tickIcon" alt="save" />
                    </button>
                    <button
                      @click="cancelEdit('email')"
                      class="isEdit isEditCancle"
                    >
                      <i class="fa fa-times" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="customer-name2">
              <h5 class="sub-heading1">Phone</h5>
              <div class="customerNameEdit2">
                <h6
                  class="sub-heading2"
                  :class="isEditable.phone ? 'focusInput' : ''"
                  :contenteditable="isEditable.phone"
                  @input="updateText('phone', $event)"
                  ref="editablePhone"
                >
                  {{ demo.phone }}
                </h6>
                <div class="customerNameEdit">
<!--                  <button v-if="!isEditable.phone" @click="toggleEdit('phone')">-->
<!--                    <img :src="pencilEdit" alt="Edit" />-->
<!--                  </button>-->

                  <div v-if="isEditable.phone" class="editableButton">
                    <button @click="saveEdit('phone')" class="isEdit">
                      <img :src="tickIcon" alt="save" />
                    </button>
                    <button
                      @click="cancelEdit('phone')"
                      class="isEdit isEditCancle"
                    >
                      <i class="fa fa-times" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="customer-name2">
              <h5 class="sub-heading1">Country</h5>
              <div class="customerNameEdit2">
                <h6
                    class="sub-heading2"
                    :class="isEditable.username ? 'focusInput' : ''"
                    :contenteditable="isEditable.username"
                    @input="updateText('username', $event)"
                    ref="editableUsername"
                >
                  {{ demo.country }}
                </h6>
                <div class="customerNameEdit">
                  <!--                  <button-->
                  <!--                    v-if="!isEditable.username"-->
                  <!--                    @click="toggleEdit('username')"-->
                  <!--                  >-->
                  <!--                    <img :src="pencilEdit" alt="Edit" />-->
                  <!--                  </button>-->

                  <div v-if="isEditable.username" class="editableButton">
                    <button @click="saveEdit('username')" class="isEdit">
                      <img :src="tickIcon" alt="save" />
                    </button>
                    <button
                        @click="cancelEdit('username')"
                        class="isEdit isEditCancle"
                    >
                      <i class="fa fa-times" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
<!--            <div class="customer-name2">-->
<!--              <h5 class="sub-heading1">Fax</h5>-->
<!--              <div class="customerNameEdit2">-->
<!--                <h6-->
<!--                  class="sub-heading2"-->
<!--                  :class="isEditable.fax ? 'focusInput' : ''"-->
<!--                  :contenteditable="isEditable.fax"-->
<!--                  @input="updateText('fax', $event)"-->
<!--                  ref="editableFax"-->
<!--                >-->
<!--                  {{ fax }}-->
<!--                </h6>-->
<!--                <div class="customerNameEdit">-->
<!--&lt;!&ndash;                  <button v-if="!isEditable.fax" @click="toggleEdit('fax')">&ndash;&gt;-->
<!--&lt;!&ndash;                    <img :src="pencilEdit" alt="Edit" />&ndash;&gt;-->
<!--&lt;!&ndash;                  </button>&ndash;&gt;-->

<!--                  <div v-if="isEditable.fax" class="editableButton">-->
<!--                    <button @click="saveEdit('fax')" class="isEdit">-->
<!--                      <img :src="tickIcon" alt="save" />-->
<!--                    </button>-->
<!--                    <button-->
<!--                      @click="cancelEdit('fax')"-->
<!--                      class="isEdit isEditCancle"-->
<!--                    >-->
<!--                      <i class="fa fa-times" aria-hidden="true"></i>-->
<!--                    </button>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="customer-name2">-->
<!--              <h5 class="sub-heading1">Address</h5>-->
<!--              <div class="customerNameEdit2">-->
<!--                <h6-->
<!--                  class="sub-heading2"-->
<!--                  :class="isEditable.address ? 'focusInput' : ''"-->
<!--                  :contenteditable="isEditable.address"-->
<!--                  @input="updateText('address', $event)"-->
<!--                  ref="editableAddress"-->
<!--                >-->
<!--                  {{ address }}-->
<!--                </h6>-->
<!--                <div class="customerNameEdit">-->
<!--&lt;!&ndash;                  <button&ndash;&gt;-->
<!--&lt;!&ndash;                    v-if="!isEditable.address"&ndash;&gt;-->
<!--&lt;!&ndash;                    @click="toggleEdit('address')"&ndash;&gt;-->
<!--&lt;!&ndash;                  >&ndash;&gt;-->
<!--&lt;!&ndash;                    <img :src="pencilEdit" alt="Edit" />&ndash;&gt;-->
<!--&lt;!&ndash;                  </button>&ndash;&gt;-->

<!--                  <div v-if="isEditable.address" class="editableButton">-->
<!--                    <button @click="saveEdit('address')" class="isEdit">-->
<!--                      <img :src="tickIcon" alt="save" />-->
<!--                    </button>-->
<!--                    <button-->
<!--                      @click="cancelEdit('address')"-->
<!--                      class="isEdit isEditCancle"-->
<!--                    >-->
<!--                      <i class="fa fa-times" aria-hidden="true"></i>-->
<!--                    </button>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="customer-name2">-->
<!--              <h5 class="sub-heading1">Priority</h5>-->
<!--              <div class="customerNameEdit2">-->
<!--                <h6-->
<!--                  class="sub-heading2"-->
<!--                  :class="isEditable.priority ? 'focusInput' : ''"-->
<!--                  :contenteditable="isEditable.priority"-->
<!--                  @input="updateText('priority', $event)"-->
<!--                  ref="editablePriority"-->
<!--                >-->
<!--                  {{ priority }}-->
<!--                </h6>-->
<!--                <div class="customerNameEdit">-->
<!--&lt;!&ndash;                  <button&ndash;&gt;-->
<!--&lt;!&ndash;                    v-if="!isEditable.priority"&ndash;&gt;-->
<!--&lt;!&ndash;                    @click="toggleEdit('priority')"&ndash;&gt;-->
<!--&lt;!&ndash;                  >&ndash;&gt;-->
<!--&lt;!&ndash;                    <img :src="pencilEdit" alt="Edit" />&ndash;&gt;-->
<!--&lt;!&ndash;                  </button>&ndash;&gt;-->

<!--                  <div v-if="isEditable.priority" class="editableButton">-->
<!--                    <button @click="saveEdit('priority')" class="isEdit">-->
<!--                      <img :src="tickIcon" alt="save" />-->
<!--                    </button>-->
<!--                    <button-->
<!--                      @click="cancelEdit('priority')"-->
<!--                      class="isEdit isEditCancle"-->
<!--                    >-->
<!--                      <i class="fa fa-times" aria-hidden="true"></i>-->
<!--                    </button>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
            <div class="customer-name2" v-if="demo.status === 3">
              <h5 class="sub-heading1">Status</h5>
              <div class="customerNameEdit2">
                <h6
                  class="sub-heading2"
                  :class="isEditable.status ? 'focusInput' : ''"
                  :contenteditable="isEditable.status"
                  @input="updateText('status', $event)"
                  ref="editableStatus"
                >
                  <span class="color-default font-weight-bold">Rejection Reason</span> <br>
                  <span>{{demo.reject_msg}}</span>
                </h6>
                <div class="customerNameEdit">
                  <button
                    v-if="!isEditable.status"
                    @click="toggleEdit('status')"
                  >
                    <img :src="pencilEdit" alt="Edit" />
                  </button>

                  <div v-if="isEditable.status" class="editableButton">
                    <button @click="saveEdit('status')" class="isEdit">
                      <img :src="tickIcon" alt="save" />
                    </button>
                    <button
                      @click="cancelEdit('status')"
                      class="isEdit isEditCancle"
                    >
                      <i class="fa fa-times" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import pencilEdit from "../../assets/images/pencil-edit.svg";
import notesIcon from "../../assets/images/notes.svg";
import emailIcon from "../../assets/images/email.svg";
import callIcon from "../../assets/images/call.svg";
import meetIcon from "../../assets/images/meet.svg";
import taskIcon from "../../assets/images/task.svg";
import tickIcon from "../../assets/images/tick.svg";
import demotask from "../../assets/images/demo-task.svg";
import setestimated from "../../assets/images/set-estimated.svg";
import setfollowup from "../../assets/images/set-followup.svg";
import setpriority from "../../assets/images/set-priority.svg";
import dropdownarrow from "../../assets/images/dropdown-arrow.svg";
import deleteIcon from "../../assets/images/delete-icon.svg";
import avatarIcon from "../../assets/images/avatar7.png";
import axios from "axios";

export default {
  name: "CustomerDetail",
  data() {
    return {
      isEditable: {
        name: false,
        username: false,
        email: false,
        phone: false,
        fax: false,
        address: false,
        priority: false,
        status: false,
      },
      name: "Customer Name",
      username: "john-doe",
      email: "john-doe@emailaddress.com",
      phone: "+1 234 567890",
      fax: "+1 234 567890",
      address: "940 Goldendale Dr, Wasilla, Alaska 99654, USA",
      priority: "high",
      status: "qualified",
      originalValues: {
        name: "Customer Name",
        username: "john-doe",
        email: "john-doe@emailaddress.com",
        phone: "+1 234 567890",
        fax: "+1 234 567890",
        address: "940 Goldendale Dr, Wasilla, Alaska 99654, USA",
        priority: "high",
        status: "qualified",
      },
      showPriorityDropdown: false,
      setHeight: false,
      pencilEdit: pencilEdit,
      notesIcon: notesIcon,
      emailIcon: emailIcon,
      callIcon: callIcon,
      meetIcon: meetIcon,
      taskIcon: taskIcon,
      tickIcon: tickIcon,
      avatarIcon:avatarIcon,
      progressValue: 100,
      progressMax: 100,
      demotask: demotask,
      setestimated: setestimated,
      setfollowup: setfollowup,
      setpriority: setpriority,
      dropdownarrow: dropdownarrow,
      deleteIcon: deleteIcon,

      //data props
      page: 0,
      tab: 1,
      leadId: null,
      leadWithData: null,
      customerDetail:[],
    };
  },

  mounted() {
    this.leadId = this.$route.params.id;
    this.getLeadQuestionnaire(this.$route.params.id);
  },
  computed: {
    demo: function () {
      return this.$store.getters['users/demoRequest'];
    },
    onBoarding: function () {
      return this.$store.getters['users/onBoarding'];
    },
  },

  created: function () {
    this.$store.dispatch('users/getDemo', this.$route.params.id);
  },

  methods: {
    addCommnetToSupport(event) {
      this.$store.dispatch("modal/update", {
        action: "add_comment_for_support_ticket",
        title: `Title: ${this.customerDetail.company}` ,
        flag:false,
        formData: {
          lead_id: event.currentTarget.dataset.id,
          component: "lead-note"
        },
        component: supportComment,
      });
    },
    togglePriorityDropdown() {
      this.showPriorityDropdown = !this.showPriorityDropdown;
       this.setHeight = !this.setHeight;
    },
    toggleEdit(field) {
      if (!this.isEditable[field]) {
        this.originalValues[field] = this[field];
      }
      this.isEditable[field] = !this.isEditable[field];
      this.$nextTick(() => {
        if (this.isEditable[field]) {
          this.$refs[
            `editable${field.charAt(0).toUpperCase() + field.slice(1)}`
          ].focus();
        }
      });
    },
    updateText(field, event) {
      this[field] = event.target.innerText;
    },
    saveEdit(field) {
      this.isEditable[field] = false;
    },
    cancelEdit(field) {
      this[field] = this.originalValues[field];
      this.isEditable[field] = false;
    },

    getLeadQuestionnaire(id) {
      const permission = {
        headers: {
          'X-Permission': 'lead_prospection_question'
        }
      };
      axios.get(`/admin/users/get-lead-questionnaire/${id}`,permission)
          .then((response) => {
            this.leadWithData = response.data.leadWithData;
          })
          .catch((error) => {
            console.error(error);
          });
    },
    openTab(tabName) {
      this.$emit('tab-selected', tabName);
    },


  },
};
</script>

<style scoped>
.interested-content, .tooltip.b-tooltip .tooltip-inner{
  background-color:var(--green-1) !important;
  color:var(--white) !important;
  padding: 4px 8px 4px 8px !important;
  border-radius: 100px !important;
  font-size: 12px !important;
  font-weight: 700 !important;
  line-height: 14.4px;
  letter-spacing: 0.005em;
  text-align: center !important;
  text-transform: uppercase;
  font-family: Mulish;
}
.bs-tooltip-bottom .arrow::before, .bs-tooltip-auto[x-placement^="bottom"] .arrow::before{
  border-bottom-color: var(--green) !important;
}
</style>